module.exports = __webpack_public_path__ + "static/media/iconParentsActive.ccb148dc.svg";